import classNames from "classnames/bind";
import styles from "./InfoUserItem.module.css";
import PropTypes from "prop-types";
import { DateTimeIcon } from "../../../../components/Icons/Icons";

const cx = classNames.bind(styles)
function InfoUserItem({ label, disabled, value, onChange, name, bigSize, type, time, error, full, placeholder, size, style = {}}) {
    const handleChange = (e) => {
        onChange(e.target.value, name)
    }
    return (
        <>
            <div className={cx('user-item', { bigSize, full })} style={{...style}}>
                <label className={cx('user-label')}>{label}</label>
                <input
                    name={name}
                    className={cx('user-input', error && 'error-border', size ? size : '')}
                    disabled={disabled ? true : false}
                    value={value?value :''}
                    onChange={(e) => handleChange(e)}
                    // type={type}
                    placeholder={placeholder}
                />
                {type === 'date' || time ? <span className={cx('icon-date')}><DateTimeIcon /></span> : ''}
                {error && <span className={cx('error')}>Kiểm tra lại thông tin</span>}
            </div>
        </>
    )
}



export default InfoUserItem;